// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__lLR0p","iconContainer":"styles_iconContainer__kJsZK","icon":"styles_icon__R7ge1"};